class ImageComparisonWindow extends HTMLElement {
  constructor() {
    super();
    this.isDragging = false;
    this.isFinePointer = window.matchMedia('(pointer: fine)').matches;
    this.activePointerId = null;
  }

  connectedCallback() {
    this.setSplit(50);

    if (this.isFinePointer) {
      window.addEventListener('pointermove', this.handleWindowPointerMove);
    }

    this.addEventListener('pointerdown', this.handlePointerDown);
    this.addEventListener('pointermove', this.handlePointerMove);
    this.addEventListener('pointerup', this.handlePointerUp);
    this.addEventListener('pointercancel', this.handlePointerUp);
  }

  disconnectedCallback() {
    window.removeEventListener('pointermove', this.handleWindowPointerMove);
    this.removeEventListener('pointerdown', this.handlePointerDown);
    this.removeEventListener('pointermove', this.handlePointerMove);
    this.removeEventListener('pointerup', this.handlePointerUp);
    this.removeEventListener('pointercancel', this.handlePointerUp);
  }

  handleWindowPointerMove = (event) => {
    if (!this.isFinePointer) return;
    this.updateFromViewport(event.clientX);
  };

  handlePointerDown = (event) => {
    if (this.isFinePointer) return;

    this.isDragging = true;
    this.activePointerId = event.pointerId;
    this.setPointerCapture(event.pointerId);
    this.updateFromViewport(event.clientX);
    event.preventDefault();
    event.stopPropagation();
  };

  handlePointerMove = (event) => {
    if (this.isFinePointer || !this.isDragging || event.pointerId !== this.activePointerId) return;

    this.updateFromViewport(event.clientX);
    event.preventDefault();
    event.stopPropagation();
  };

  handlePointerUp = (event) => {
    if (this.isFinePointer || event.pointerId !== this.activePointerId) return;

    this.isDragging = false;
    this.activePointerId = null;

    if (this.hasPointerCapture(event.pointerId)) {
      this.releasePointerCapture(event.pointerId);
    }
  };

  updateFromViewport(clientX) {
    const width = window.innerWidth || document.documentElement.clientWidth;
    if (!width) return;

    this.setSplit((clientX / width) * 100);
  }

  setSplit(value) {
    const split = Math.min(100, Math.max(0, value));
    this.style.setProperty('--comparison-split', `${split}%`);
  }
}

if (!customElements.get('image-comparison-window')) {
  customElements.define('image-comparison-window', ImageComparisonWindow);
}
